module.exports = __webpack_public_path__ + "img/9791159923227.e60a5809.jpg";